import type React from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';
import { InlineMessage } from '@change-corgi/design-system-legacy/components/alerts';

import { RichMediaTextEditorSunrise } from 'src/app/shared/components/richTextEditor';

import { useDescription } from './hooks/useDescription';

export const Description: React.FC = () => {
	const { translate } = useI18n();
	const { data, actions } = useDescription();
	return (
		<div id="edit_description" sx={{ '.tox': { height: ['220px !important', '400px !important'] } }}>
			<RichMediaTextEditorSunrise
				initialValue={data.value}
				onEditorChange={actions.handleChange}
				hideLabel
				// TODO: define page-specific i18n key
				ariaLabel={translate('corgi.sap.description.a11y.aria_label')}
				// TODO: define page-specific i18n key
				descriptiveLabel={translate('corgi.sap.description.a11y.descriptive_label')}
				aria-describedby="description_error"
				aria-required
			/>
			{data.error && (
				<InlineMessage
					id="description_error"
					variant="error"
					labelColor="primary-black"
					size="small"
					fontWeight="normal"
				>
					{data.error}
				</InlineMessage>
			)}
		</div>
	);
};
